/* eslint-disable promise/prefer-await-to-then */
import { makeApiCall } from "./apiService"

export interface IDocumentsAndFolderResponse {
	documents: DocumentOrFolderRaw[]
}

export interface DocumentOrFolderRaw {
	Folder?: FolderOrFileProps | null
	Author?: AuthorOrEditor
	Editor?: AuthorOrEditor
	FileDirRef: string
	FileDirRefLower: string
	FileLeafRef: string
	Created?: string
	Modified?: string
	FileRef: string
	FileRefLower: string
	FSObjType: number
	File?: FolderOrFileProps | null
}

interface ShaarePointDocument {
	FileLeafRef: string
	ID: string
	Created: string
	Author: string
	Modified: string
	Editor: string
	FileRef: string
	FileDirRef: string
	FSObjType: string
}

export interface FolderOrFileProps {
	ServerRelativeUrl: string
	ServerRelativeUrlLower: string
}

export interface AuthorOrEditor {
	ID: number
	Title: string
}

export enum DocumentFolderType {
	File = 0,
	Folder = 1
}

export interface IDocumentOrFolder {
	FolderOrFile: DocumentFolderType
	FolderRelativeUrl: string
	ServerRelativeUrl: string
	FileLeafRef: string
	PortalModifiedBy: string
	ModifiedOn: string
}

class SharePointService {
	public getAccountDocumentsForBroker = (currentUserContactId: string, currentUserName: string, accountId: string, subFolder?: string): Promise<IDocumentOrFolder[]> => {
		const subFolderQs = subFolder ? `&subFolder=${subFolder}` : ""
		return makeApiCall(`/getPortalDocumentsForGroup?groupId=${accountId}${subFolderQs}`, "GET", undefined, undefined).then(res => {
			if (res.error) {
				throw res.error
			} else {
				return res
					.filter((d: any) => d.Name.toLowerCase() !== "forms")
					.map((d: any) => {
						const retVal: IDocumentOrFolder = {
							FileLeafRef: d.Name,
							FolderOrFile: d.IsFile ? DocumentFolderType.File : DocumentFolderType.Folder,
							FolderRelativeUrl: d.FolderRelativeUrl,
							ServerRelativeUrl: d.ServerRelativeUrl,
							PortalModifiedBy: d.PortalModifiedBy,
							ModifiedOn: d.Modified
						}
						return retVal
					})
			}
		})
	}

	public uploadPortalDocuments = (currentUserContactId: string, currentUserName: string, groupId: string, filePath: string, documents: FileList): Promise<void> => {
		const formData = new FormData()
		for (let i = 0; i < documents.length; i++) {
			const doc = documents[i]
			formData.append("files", doc, doc.name)
		}
		return makeApiCall(`/uploadPortalDocuments?groupId=${groupId}&docPath=${filePath}`, "POST", formData, undefined, undefined, true)
			.then(res => {
				if (res.error) {
					throw res.error
				} else {
					return res
				}
			})
			.catch(err => {
				throw err
			})
	}

	public downloadPortalDocument = (currentUserContactId: string, currentUserName: string, groupId: string, filePath: string): Promise<Blob> => {
		return makeApiCall(`/downloadPortalDocument?groupId=${groupId}&docPath=${filePath}`, "GET", undefined, undefined).then(res => {
			if (res.error) {
				throw res.error
			} else {
				return new Blob([res])
			}
		})
	}

	public trimSlashes = (str: string) => {
		let retVal = str
		if (retVal.endsWith("/")) {
			retVal = retVal.substring(0, retVal.length - 1)
		} else if (retVal.startsWith("/")) {
			retVal = retVal.substring(1)
		}
		return retVal
	}

	private _executeDocumentRequest = (apiPath: string, headers: any): Promise<ArrayBuffer> => {
		return new Promise((resolve, reject) => {
			const oReq = new XMLHttpRequest()
			oReq.open("GET", apiPath, true)
			oReq.responseType = "arraybuffer"
			Object.keys(headers || {}).forEach(key => {
				oReq.setRequestHeader(key, headers[key])
			})
			oReq.onload = function (oEvent) {
				const status = oReq.status
				if (status === 200) {
					const arrayBuffer: ArrayBuffer = oReq.response
					//let blobFile = new Blob([arrayBuffer]);
					resolve(arrayBuffer)
				} else {
					reject(oReq.responseText)
				}
			}
			oReq.onerror = reject
			oReq.send()
		})
	}

	/*public downloadFileFromSharePoint = (webServerRelativeUrl: string, fileUrl: string): Promise<Blob> => {
        const downloadDocumentsApiPath = `${helperService.getWebServiceUrl()}/getBufferOfSharePointFile?webServerRelativeUrl=${webServerRelativeUrl}&fileServerRelativeUrl=${encodeURIComponent(fileUrl)}`;
        const downloadDocumentsApiPathHeaders = {
            "authorization": helperService.webServiceAuthKey,
            "accept": "application/image"
        };
        return this._executeDocumentRequest(downloadDocumentsApiPath, downloadDocumentsApiPathHeaders).then(bufferFile => {
            const blobFile = new Blob([bufferFile]);
            return blobFile;
        })
    }*/
}

const sharePointService = new SharePointService()
export default sharePointService
